import type { TotaisDeMesclagemResponse } from '@/api/generated/model';

const TOTAIS: { chave: keyof TotaisDeMesclagemResponse; rotulo: string }[] = [
  { chave: 'exames', rotulo: 'exames' },
  { chave: 'prontuarios', rotulo: 'prontuários' },
  { chave: 'requisicoes', rotulo: 'solicitações de exame' },
  { chave: 'receituarios', rotulo: 'receituários' },
  { chave: 'tratamentos', rotulo: 'tratamentos' },
  { chave: 'pesos', rotulo: 'pesagens' },
  { chave: 'diagnosticos', rotulo: 'diagnósticos' },
  { chave: 'discussoes', rotulo: 'discussões técnicas' },
  { chave: 'gravacoes', rotulo: 'gravações de consulta' },
];

/** "3 exames, 1 prontuário…" — só o que existe. */
export function resumirTotais(totais: TotaisDeMesclagemResponse): string {
  const partes = TOTAIS.filter(({ chave }) => totais[chave] > 0).map(
    ({ chave, rotulo }) => `${totais[chave]} ${rotulo}`,
  );
  return partes.length > 0 ? partes.join(', ') : 'nenhum registro clínico';
}
